import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useForm } from "react-hook-form";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import keyIcon from "../../assets/svgIcons/key-icon.svg";
import mailIcon from "../../assets/svgIcons/mail-icon.svg";
import inactive_check_circle from "../../assets/icons/inactive-check-circle.png";
import active_check_circle from "../../assets/icons/active-check-circle.png";
import Illustration from "../../assets/images/image-2.png";
import appLogo from "../../assets/images/logo150.png";
import prodLogo from "../../assets/images/logo_prod_1.png";
import devLogo from "../../assets/images/logo_dev.png";
import stageLogo from "../../assets/images/logo_stage.png";

import RenderIf from "../../components/renderIf";
import { SagaActions } from "../../redux/actionTypes";
import { ROUTE_NAMES } from "../../constants/routeNames";

import { InputWrapper, AuthPageWrapper } from "./auth.styled";
import FooterOne from "../../components/footer/footerOne";

import { validate } from "../../constants/validationExp";
import { loginWithMailReq } from "../../api/auth/loginRequest";

type Inputs = {
  emailIs: string;
  passwordIs: string;
};

export const LoginPage = () => {
  const navigation = useNavigate();
  const Dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>();
  const email = watch("emailIs");

  const [btnLoading, setbtnLoading] = useState(false);

  const _emailError = errors.emailIs?.message;
  const _passwordError = errors.passwordIs?.message;
  const _validEmail = validate.email.test(email);
  const forgotPassword = true;

  const loginFun = async (data: Inputs) => {
    try {
      setbtnLoading(true);
      const body = {
        emailIs: data.emailIs,
        passwordIs: data.passwordIs,
      };
      const res = await loginWithMailReq(body);


      if (
        res?.data?.role === 301 ||
        res?.data?.role === 303 ||
        res?.data?.role === 302 ||
        res?.data?.role === 200
      ) {
        toast.error("You are not authorised to access this");
        setbtnLoading(false);
        return;
      }
      // if (res?.data?.role != 102 ) {
      //   toast.error("You are not authorised to access this")
      //   // return
      // }

      navigation(`${ROUTE_NAMES.Home}/${ROUTE_NAMES.Dashboard}`);
    } catch (error: any) {
      console.log(error, "loginPage->LoginPage->resendOtpFun error");
      setbtnLoading(false);
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "loginPage2",
          methodName: "loginFun",
          type: "error",
        },
      });
    }
  };

  const handleButtonClick = ({ key, data }: { key: string; data?: any }) => {
    const btnFun: any = {
      login: (data: Inputs) => loginFun(data),
      signup: () => navigation(ROUTE_NAMES.Signup),
      forgotPwsd: () =>
        navigation(`${ROUTE_NAMES.Signup}`, { state: forgotPassword }),
    };
    btnFun[key](data);
  };

  return (
    <AuthPageWrapper>
      <Container fluid className=" flex-grow-1">
        <Row className=" h-100">
          <Col
            lg={7}
            className="d-flex flex-column align-items-center justify-content-center pt-lg-5 pb-lg-2 "
          >
            <div className={`banner `}>
              <img src={Illustration} />
            </div>
          </Col>
          <Col lg={5} className=" border-info px-lg-5">
            <div className={`inputsContainer h-100 py-2  border-info`}>
              <Col lg={3} xs={4} sm={2} className="m-2 mb-3">
                <div className="logo_block">
                  {/* <img src={appLogo} /> */}
                  {process.env.REACT_APP__ENV_IS === "prod" && (
                    <img src={prodLogo} />
                  )}
                  {process.env.REACT_APP__ENV_IS === "dev" && (
                    <img src={devLogo} />
                  )}
                  {process.env.REACT_APP__ENV_IS === "stage" && (
                    <img src={stageLogo} />
                  )}
                </div>
              </Col>
              <div className="inputs_block w-100 py-1 px-lg-4 py-4 px-xs-2  border-info">
                <form
                  onSubmit={handleSubmit((data) => {
                    loginFun(data);
                  })}
                  className={` flex-1 d-flex flex-column  mx-3 h-100 border-info`}
                >
                  <div className="mb-3">
                    <h4 className={`x-lg-text`}>Login</h4>
                  </div>
                  <div className="">
                    <InputWrapper>
                      <p className={`md-text mb-1`}>{"Email ID"}</p>
                      <div className="d-flex ">
                        <div className="flex-grow-1 ">
                          <div
                            className={`input_box  ${
                              _emailError && "border-danger"
                            }`}
                          >
                            <div className={`icon_box ms-2`}>
                              <img src={mailIcon} className="" />
                            </div>

                            <input
                              className={`flex-grow-1`}
                              {...register("emailIs", {
                                required: " Please enter Email",
                                pattern: {
                                  value: validate.email,
                                  message: "Entered incorrect email format",
                                },
                              })}
                            />

                            <div className={`icon_box me-2`}>
                              {_validEmail ? (
                                <div className={`  px-1 py-1`}>
                                  <img
                                    className="image_icon"
                                    src={active_check_circle}
                                  />
                                </div>
                              ) : (
                                <img src={inactive_check_circle} />
                              )}
                            </div>
                          </div>
                          <RenderIf isShow={!!_emailError}>
                            <p className={`x-sm-text mt-1 text-danger`}>
                              {_emailError}
                            </p>
                          </RenderIf>
                          <RenderIf isShow={!_emailError}>
                            <p className={`x-sm-text mt-1`}>
                              Corporate email ID. Example format a@b.c
                            </p>
                          </RenderIf>
                        </div>
                      </div>
                    </InputWrapper>
                  </div>
                  <p></p>
                  <div className="">
                    <InputWrapper>
                      <p className={`md-text mb-1`}>{"Password"}</p>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <div
                            className={`input_box ${
                              _passwordError && "border-danger"
                            }`}
                          >
                            <div className={`icon_box ms-2`}>
                              <img src={keyIcon} className="" />
                            </div>

                            <input
                              type="password"
                              className={`flex-grow-1 `}
                              {...register("passwordIs", {
                                required: " Please enter password",
                              })}
                            />
                          </div>
                          <RenderIf isShow={!!_passwordError}>
                            <p className={`x-sm-text mt-1 text-danger`}>
                              {_passwordError}
                            </p>
                          </RenderIf>
                          <RenderIf isShow={!_passwordError}>
                            <p className={`x-sm-text mt-1`}>
                              Password required
                            </p>
                          </RenderIf>
                        </div>
                      </div>
                    </InputWrapper>
                  </div>
                  <div className="flex-grow-1  d-flex flex-1"></div>
                  <div
                    className={`d-flex justify-content-between align-items-center mb-4`}
                  >
                    <button
                      type="button"
                      className={`forgot_password_btn`}
                      onClick={() => handleButtonClick({ key: "signup" })}
                    >
                      <div className={`d-flex align-items-center`}>
                        {/* <input type={"checkbox"} className={`me-2 ${styles.checkbox}`} /> */}
                        {/* <p className={`md-text primary-color`}>Remember me</p> */}
                        {/* <p className={`md-text primary-color`}>Sign-Up</p> */}
                      </div>
                    </button>
                    <button
                      type="button"
                      className={`forgot_password_btn`}
                      onClick={() => handleButtonClick({ key: "forgotPwsd" })}
                    >
                      <p className={`md-text primary-color`}>
                        Forgot Password?
                      </p>
                    </button>
                  </div>
                  <div className="">
                    <button className={`sbmit_btn md-text`} type="submit">
                      Login
                      <div className={`ms-2`}>
                        {btnLoading && (
                          <Spinner
                            animation="border"
                            variant="primary"
                            size="sm"
                          />
                        )}
                      </div>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <FooterOne />
    </AuthPageWrapper>
  );
};
